export default "__VITE_ASSET__kxfBk5dq__"